// src/components/ProtectedRoute.jsx
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Don't render anything until auth is confirmed
  // This prevents a flash of the wrong page
  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    // Redirect to home with the current location saved so we can redirect back
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;